import { ReactComponent as DirectoryIcon } from '../../../../../assets/icons/Navegation/directorio-ipb.svg';
import { ReactComponent as SubmenuIcon } from '../../../../../assets/icons/Navegation/submenu-flecha.svg';
import { icons, triangle, headerTitleStyle } from '../Styles/StylesIcons';
import GenericCollapse from './GenericCollapse';
import GenericNavListItem from './GenericNavListItem';
import GenericListItemButton from './MenuItemWithSubmenu';
import Popover from '@mui/material/Popover';
import Divider from '@mui/material/Divider';

const TriangleIcon = (props) => <SubmenuIcon style={triangle} {...props} />;

const MtcenterMenu = ({
  userPermissions,
  openMenuMTCenter,
  handleOpenMTCenter,
  activeStyle,
  drawerOpen,
  header,
  handlePopoverOpen,
  handlePopoverClose,
  openPopover,
  anchorEl,
}) => {
  const submenuContent = (
    <>
      {userPermissions?.includes('LIST_PAYMENTS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='LIST_PAYMENTS'
          to='/listado/tiendas'
          title='Tiendas IPB'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
      {userPermissions?.includes('LIST_PAYMENTS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='LIST_PAYMENTS'
          to='/listado/moderacion'
          title='Moderación'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
    </>
  );

  return (
    <>
      {userPermissions?.includes('LIST_PAYMENTS') && (
        <>
          <Divider style={{ margin: '0 0 4px 0' }} />
          {drawerOpen && (
            <>
              {header?.directory.kind === 'header' && (
                <div style={headerTitleStyle}>{header.directory.title}</div>
              )}
            </>
          )}
          <GenericListItemButton
            onClick={drawerOpen ? handleOpenMTCenter : handlePopoverOpen}
            className={'layout-menu-submenu'}
            title='Directorio IPB'
            IconComponent={(props) => <DirectoryIcon style={icons} {...props} />}
            openMenu={openMenuMTCenter}
          />
          {drawerOpen && (
            <GenericCollapse
              className={'layout-menu-submenu-options'}
              openMenu={openMenuMTCenter}
              userPermissions={userPermissions}
            >
              {submenuContent}
            </GenericCollapse>
          )}
          {!drawerOpen && (
            <Popover
              open={openPopover}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              onBlur={handlePopoverClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                style: { minWidth: 220 },
                onMouseLeave: handlePopoverClose,
              }}
            >
              <div style={{ padding: 8 }}>{submenuContent}</div>
            </Popover>
          )}
        </>
      )}
    </>
  );
};

export default MtcenterMenu;
